(ns iris.posts.views.user-btn
  (:require 
   [iris.posts.common :refer [route-prefix]]))

(defn user-btn
  ([user] (user-btn user route-prefix))
  ([user pfx] (user-btn user pfx true))
  ([user pfx by-staff]
   [:div {:class "btn-group btn-group-xs ip-buttons"
          :role "group"}
    [:a.btn.btn-default
     {:title (str "User " user) :href (str pfx "/user/" user)}
     (if by-staff
       [:span.text-success [:strong user]]
       user)]]))
